function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBiochar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 980 725",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "Bio-Char",
    x: 0.217,
    y: 0.196,
    width: 979.411,
    height: 724.415,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.51,655.971l78.479,-26.771l159.799,-237.034l81.433,-238.498l-220.668,158.222l-99.043,344.081Z",
    style: {
      fill: "#4d4d4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.27,272.306l-60.412,257.542l80.597,52.24l60.824,-163.938l-33.952,181.356l81.438,52.786l96.977,-336.902l-224.614,-42.901c-0.289,-0.055 -0.575,-0.115 -0.858,-0.183Z",
    style: {
      fill: "#646464"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702.758,176.507l20.859,77.847l-154.628,97.627l79.763,-233.606l54.006,58.132Z",
    style: {
      fill: "#4d4d4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.948,84.141l-55.229,-59.448l-424.564,211.631l198.41,37.896l15.697,-100.369l14.863,90.134l250.823,-179.844Z",
    style: {
      fill: "#646464"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.351,693.539c-2.892,-2.154 -4.56,-5.575 -4.476,-9.179c0.084,-3.605 1.91,-6.944 4.899,-8.96c23.374,-15.634 70.415,-47.148 75.676,-51.081c143.599,-107.36 168.449,-214.901 168.449,-214.901c-0,0 -83.129,136.766 -215.678,214.901c-56.95,-55.074 -40.04,-137.172 15.673,-188.154c72.077,-65.957 190.948,-87.719 229.827,-186.269c33.217,20.5 109.421,459.222 -190.459,397.613c-0.113,-0.023 -38.621,29.912 -59.013,45.772c-7.295,5.674 -17.478,5.781 -24.891,0.263c-0.002,-0.002 -0.005,-0.003 -0.007,-0.005Z",
    style: {
      fill: "#4ec48f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.753,606.87l-29.909,29.607l-177.494,-9.642l141.431,-209.788l201.144,-126.995l35.882,37.076l-2.91,3.394c-41.445,23.773 -84.703,45.843 -118.459,76.733c-58.33,53.377 -81.436,133.147 -49.685,199.615Z",
    style: {
      fill: "#4d4d4d"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiochar);
export default __webpack_public_path__ + "static/media/biochar.e8ebb8ae5f0d2f675d4bcfee9127f6e9.svg";
export { ForwardRef as ReactComponent };